module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-01 8.1c56c9d1.png";